import { GET_USER_INFO } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

// Define an initial state value for the app
const initialState: UserData = {
    loading: false,
    error: false,
    user_profile_id: "",
    challenge_response: "",
    user_id: "",
    terms_conditions_flag: "",
    terms_condition_accepted_at: 0,
    password_change_req: "",
    email: "",
    recovered_at: 0,
    challenge_question: "",
    pref_lang: "",
    lsuc_num: null,
    locked_on: null,
    verified_flag: "1"
}

export interface UserData extends BaseAsyncReducerState {
    "user_profile_id": string,
    "challenge_response": string,
    "user_id": string,
    "terms_conditions_flag": string,
    "terms_condition_accepted_at": number,
    "password_change_req": string,
    "email": string,
    "recovered_at": number,
    "challenge_question": string,
    "pref_lang": string,
    "lsuc_num": string | null,
    "locked_on": null | number,
    "verified_flag": "1",
}
  
function getUserInfoReducer(state = initialState, action: AppAction) {

    const { payload } = action;

    switch (action.type) {
        case GET_USER_INFO.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }

        case GET_USER_INFO.SUCCESS:

            return {
                ...state,
                ...payload as ActionPayload,
                loading: false,
                error: false,

            }

        case GET_USER_INFO.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default getUserInfoReducer;